import { Image } from 'tamagui';

export function NoSearchResult({ width, height }) {
  return <Image source={{ uri: 'https://ninjakissan.s3.ap-south-1.amazonaws.com/background/2025-02-10/skeleton.png' }} width={width} height={height} />;
}
